var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FallbackComponent } from '../common';
import { useReportAPI } from '../report/selectors';
import { useIsCompletedSimulation } from '../toastify/selector';
import { FinancialTable, ResourcingTable } from './periodTable';
import { usePeriodReportAPI } from './selectors';
var PeriodReport = function (props) {
  var _a = useReportAPI(),
    reportData = _a[0],
    fetchReportData = _a[1];
  var _b = usePeriodReportAPI(),
    periodReportData = _b[0],
    fetchPeriodReport = _b[1],
    clearPeriodReportData = _b[2];
  var basePlanId = useParams().basePlanId;
  var isCompletedSimulation = useIsCompletedSimulation(basePlanId);
  useEffect(function () {
    fetchPeriodReport();
    fetchReportData();
    return clearPeriodReportData;
  }, [fetchPeriodReport, clearPeriodReportData, fetchReportData, isCompletedSimulation]);
  return _jsx(FallbackComponent, __assign({
    requesting: !!periodReportData.requesting || !!reportData.requesting
  }, {
    children: props.children
  }));
};
export var PeriodResourcingReport = function () {
  return _jsx(PeriodReport, {
    children: _jsx(ResourcingTable, {})
  });
};
export var PeriodFinancialReport = function () {
  return _jsx(PeriodReport, {
    children: _jsx(FinancialTable, {})
  });
};